import Text from '@deprecated-ui/common/Text';
import styled from 'styled-components';

export const TableHeaderWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 26px;
  display: flex;
  align-items: center;
`;

export const DebtRatioWrapper = styled.div`
  position: absolute;
  left: 80px;
  top: 0;
  height: 100%;
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #858585;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const DebtRatioInfoChip = styled.div<{
  color?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #858585;

  ${({ color }) =>
    color &&
    `
    background-color: ${color};
  `}

  p {
    text-wrap: nowrap;
  }
`;

export const DebtRatioChip = styled(DebtRatioInfoChip)`
  position: relative;
  background-color: #ffffff;
  flex-wrap: nowrap;
  gap: 10px;
  cursor: pointer;

  > * {
    z-index: 2;
  }

  p {
    text-wrap: nowrap;
    margin: 0;
  }

  p.chip-label {
    color: #858585;
  }

  p.chip-percentage {
    color: #000000;
    font-weight: 700;
  }
`;

export const DebtRatioCountDown = styled(DebtRatioChip)`
  background-color: #f2f1fe;
  cursor: default;

  p {
    color: #8277f8;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DebtRatioOverlayProgress = styled.div<{
  width: number;
  color: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 4px;
  z-index: 1;

  width: ${({ width = 0 }) => `${width}%`};
  max-width: 100%;
  background-color: ${({ color }) => color};
`;

// BADGE
export const BadgeWrapper = styled.div<{ isForcedSell: boolean }>`
  align-items: center;
  border-radius: 4px;
  border: 1px solid #8277f8;
  color: #8277f8;
  display: flex;
  font-size: 10px;
  font-weight: 700;
  gap: 2px;
  justify-content: center;
  line-height: 14px;
  margin-left: 7px;
  padding: 2px 4px;
  text-align: center;

  svg {
    width: 12px;
    height: 12px;
    color: #8277f8;
  }

  ${({ isForcedSell }) =>
    isForcedSell &&
    `
    background: #FDEDED;
    color: #EE4A49;
    border: none;
  `};
`;

// BANNER
export const BannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #fdeded;
  gap: 8px;
  border-radius: 3px;
`;

export const BannerTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 4px;
`;

export const BannerTitle = styled(Text).attrs({
  family: 'bold',
  size: '14px',
  color: '#333333',
})`
  line-height: 18px;
`;

export const BannerDescription = styled(Text).attrs({
  size: '13px',
  color: '#333333',
})``;
